import { Img } from 'components/shared';
import Questions from "../../../../src/components/Footer/Questions";
import * as React from 'react';
export default {
  Img,
  Questions,
  React
};